<div class="notification-center">
  <div class="page-header-v2 d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0 page-title">{{ 'HEADER.NOTIFICATIONS.TITLE' | translate }}</h5>
    @if (!isArchivedTab) {
      <hc-button variant="link" (clicked)="markAllAsRead()">
        {{ 'HEADER.NOTIFICATIONS.VIEW_ALL' | translate }}
      </hc-button>
    }
  </div>

  <!-- Tabs -->
  <div class="tabs-v2 mb-3">
    <button
      class="tab-item"
      [class.active]="activeTab === 'active'"
      (click)="switchTab('active')">
      {{ 'HEADER.NOTIFICATIONS.ACTIVE' | translate }}
    </button>
    <button
      class="tab-item"
      [class.active]="activeTab === 'archived'"
      (click)="switchTab('archived')">
      {{ 'HEADER.NOTIFICATIONS.ARCHIVED' | translate }}
    </button>
  </div>

  <!-- Filters -->
  <div class="notification-filters mb-3">
    <div class="row g-2 align-items-end">
      <div class="col-md-6">
        <hc-input-dropdown
          [(ngModel)]="selectedType"
          [options]="typeOptions"
          (ngModelChange)="onFilterChange()">
        </hc-input-dropdown>
      </div>
      <div class="col-md-6">
        <hc-form-field controlType="checkbox">
          <hc-checkbox
            [label]="'HEADER.NOTIFICATIONS.UNREAD_ONLY' | translate"
            [(ngModel)]="showOnlyUnread"
            (changed)="onFilterChange()">
          </hc-checkbox>
        </hc-form-field>
      </div>
    </div>
  </div>

  <!-- Error State -->
  @if (error$ | async; as error) {
    <div class="alert alert-danger d-flex justify-content-between align-items-center">
      <span>{{ error }}</span>
      <hc-button variant="link" leftIcon="x" (clicked)="clearError()">
      </hc-button>
    </div>
  }

  <!-- Notifications List -->
  <div class="notifications-list">
    @if (notifications$ | async; as notifications) {
      @if (getVisibleNotifications(notifications).length === 0) {
        <div class="text-center p-4 text-muted">
          <lucide-icon name="bell" class="display-4"></lucide-icon>
          <p class="mt-2">{{ 'HEADER.NOTIFICATIONS.NO_NOTIFICATIONS_FOUND' | translate }}</p>
        </div>
      }
      @for (notification of getVisibleNotifications(notifications); track trackByNotificationId($index, notification)) {
        <div
          class="notification-item card mb-2"
          [class.unread]="!notification.isRead"
          (click)="handleNotificationClick(notification)"
          (keydown.enter)="handleNotificationClick(notification)"
          tabindex="0"
          role="button">
          <div class="card-body p-3">
            <div class="d-flex p-0">
              <!-- Icon -->
              <div class="notification-icon me-3">
                <lucide-icon [name]="getNotificationIcon(notification)" [class]="getNotificationColor(notification) + ' icon-lg'"></lucide-icon>
              </div>
              <!-- Content -->
              <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <h6 class="mb-0 fw-semibold">{{ notification.titleKey ? (notification.titleKey | translate) : notification.title }}</h6>
                  <div class="d-flex align-items-center p-0 responsive-badge">
                    <hc-badge
                      [color]="getPriorityBadgeColor(notification.priority)"
                      variant="heavy"
                      size="small"
                      class="me-2">
                      {{ 'HEADER.NOTIFICATIONS.PRIORITY_' + notification.priority.toUpperCase() | translate }}
                    </hc-badge>
                    <small class="text-muted">{{ getTimeAgo(notification.createdAt) }}</small>
                  </div>
                </div>
                <p class="mb-2 text-muted">{{ notification.body }}</p>
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <hc-badge color="neutral" variant="light" size="small">{{ 'HEADER.NOTIFICATIONS.TYPE_' + notification.type.toUpperCase() | translate }}</hc-badge>
                    @if (notification.hotel?.name) {
                      <hc-badge color="neutral" variant="light" size="small" class="ms-1">{{ notification.hotel?.name }}</hc-badge>
                    }
                    @if (!notification.isRead) {
                      <hc-badge color="secondary" variant="heavy" size="small" class="ms-1">{{ 'HEADER.NOTIFICATIONS.NEW' | translate }}</hc-badge>
                    }
                  </div>
                  <!-- Action Buttons -->
                  <div class="d-flex gap-1" role="group">
                    @if (notification.actionUrl) {
                      <hc-button variant="secondary">
                        {{ ((notification.actionLabel ?? '') | translate) || ('HEADER.NOTIFICATIONS.VIEW' | translate) }}
                      </hc-button>
                    }
                    @if (!isArchivedTab) {
                      <hc-button variant="secondary"
                        leftIcon="archive"
                        (clicked)="archiveNotification(notification, $event)"
                        [ariaLabel]="'HEADER.NOTIFICATIONS.ARCHIVE' | translate">
                      </hc-button>
                    }
                    <hc-button variant="destructive-secondary"
                      leftIcon="trash-2"
                      (clicked)="deleteNotification(notification, $event)"
                      [ariaLabel]="'HEADER.NOTIFICATIONS.DELETE' | translate">
                    </hc-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>

  <!-- Load More -->
  @if ((state$ | async); as state) {
    <div class="text-center mt-3">
      @if (state.notifications.length < state.total) {
        <div>
          <hc-button variant="secondary" (clicked)="loadMore()" [disabled]="!!(loading$ | async)" [loading]="!!(loading$ | async)">
            {{ 'common.load_more' | translate }}
          </hc-button>
        </div>
      }
    </div>
  }
</div>
